import {
  useGetEvaluationQuery,
  useUpdateEvaluationAcademicInfoMutation,
  useUpdateEvaluationPersonalInfoMutation,
  useDeleteTranscriptMutation,
  useMarkTranscriptReadyMutation,
  useUpdateTranscriptMutation,
} from '@teachur/http-client';
import type {
  UpdateAcademicInfoInput,
  UpdatePersonalInfoInput,
  UpdateTranscriptInput,
} from '@teachur/http-client';

export const useEvaluation = () => {
  const query = useGetEvaluationQuery();

  const personalInfo = useUpdateEvaluationPersonalInfoMutation();
  const academicInfo = useUpdateEvaluationAcademicInfoMutation();
  const deleteTranscript = useDeleteTranscriptMutation();
  const markReady = useMarkTranscriptReadyMutation();
  const updateTranscript = useUpdateTranscriptMutation();

  return {
    evaluation: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,

    updatePersonalInfo: (body: UpdatePersonalInfoInput) => personalInfo.mutateAsync(body),
    updateAcademicInfo: (body: UpdateAcademicInfoInput) => academicInfo.mutateAsync(body),
    removeTranscript: (id: number) => deleteTranscript.mutateAsync(id),
    markTranscriptReady: (id: number) => markReady.mutateAsync(id),
    updateTranscript: (id: number, body: UpdateTranscriptInput) =>
      updateTranscript.mutateAsync({ id, body }),

    isSaving: personalInfo.isPending || academicInfo.isPending,
    isRemoving: deleteTranscript.isPending,
    isMarkingReady: markReady.isPending,
    isUpdatingTranscript: updateTranscript.isPending,
  };
};
